import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defaultBaseQuerySSO } from '../../utils/API/fetchBaseQuery';
import { transformRequestSSO } from '../../utils/API/requestMiddleware';

const authSSOAPI = createApi({
  baseQuery: defaultBaseQuerySSO, // Replace with your API endpoint
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'Authentication/AdminLogin',
        method: 'POST',
        body: transformRequestSSO(credentials)
      }),
      invalidatesTags: ['authentication'],
      transformResponse: transformSucessResponse,
      transformErrorResponse: transformErrorResponse
    }),

    validateToken: builder.mutation({
      query: (credentials) => ({
        url: 'Authentication/ValidateToken',
        method: 'POST',
        body: transformRequestSSO(credentials)
      }),
      invalidatesTags: ['authentication'],
      transformResponse: transformSucessResponse,
      transformErrorResponse: transformErrorResponse
    }),

  }),
});

export const { useLoginMutation, useValidateTokenMutation } = authSSOAPI;
export default authSSOAPI;
